import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "p-suggest-panel__wrap" }
const _hoisted_2 = { class: "p-suggest-panel__suggest_item__label" }
const _hoisted_3 = {
  key: 0,
  class: "p-suggest-panel__suggest_item__id"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueSimpleSuggest = _resolveComponent("VueSimpleSuggest")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VueSimpleSuggest, {
      modelValue: _ctx.query,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query) = $event)),
      "display-attribute": "label",
      "value-attribute": "id",
      styles: _ctx.styles,
      destyled: true,
      list: _ctx.getSuggestionList,
      "min-length": 3,
      debounce: 200
    }, {
      "suggestion-item": _withCtx(({ suggestion }) => [
        _createElementVNode("span", _hoisted_2, _toDisplayString(suggestion.label), 1),
        (suggestion.id)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "ID: " + _toDisplayString(suggestion.id), 1))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["modelValue", "styles", "list"])
  ]))
}